import { Table } from "@/features/Table";
import { type G4MetaData, g4_metadata_columns } from "./columns";
import { type FilterG4MetadataSchema, FilterG4Metadata } from "./filter";
import { Tables } from "../../../gen/tableNames/tables";
import { Clients } from "../../../lib/clients";

export const G4MetadataTable = () => {
  return (
    <Table<G4MetaData, FilterG4MetadataSchema>
      label="Metadata"
      client={Clients.G4}
      table_name={Tables.G4_METADATA}
      columns={g4_metadata_columns}
      filter={<FilterG4Metadata />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.G4}/${Tables.G4_METADATA}/new`,
        },
      ]}
    />
  );
};
